(function () {
  function initImageSliderWithText() {
    document.querySelectorAll('.image-slider-with-text__slider').forEach((sliderEl) => {
      if (sliderEl.dataset.initialized === 'true') return;

      const wrapper = sliderEl.querySelector('.swiper-wrapper');
      const slides = wrapper ? wrapper.querySelectorAll('.swiper-slide') : [];
      if (slides.length === 0) return;

      const sectionId = sliderEl.dataset.sectionId;
      const autoplayMs = parseInt(sliderEl.dataset.autoplay, 10) || 0;
      const showDots = sliderEl.dataset.showDots === 'true' && slides.length > 1;

      const sliderOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slides.length > 1,
        grabCursor: true,
        allowTouchMove: true,
        threshold: 2,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        on: {
          init(swiper) {
            sliderEl.dataset.initialized = 'true';
          },
        },
      };

      if (showDots) {
        const paginationEl = sliderEl.querySelector('.swiper-pagination');
        if (paginationEl) {
          sliderOptions.pagination = {
            el: paginationEl,
            clickable: true,
          };
        }
      }

      if (autoplayMs > 0 && slides.length > 1) {
        sliderOptions.autoplay = {
          delay: autoplayMs,
          disableOnInteraction: false,
        };
      }

      if (typeof window.FoxTheme === 'undefined' || !window.FoxTheme.Carousel) return;

      const modules = [window.FoxTheme.Swiper.Autoplay, window.FoxTheme.Swiper.EffectFade];
      const carousel = new window.FoxTheme.Carousel(sliderEl, sliderOptions, modules);
      carousel.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageSliderWithText);
  } else {
    initImageSliderWithText();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initImageSliderWithText);
  }
})();
